import { render, staticRenderFns } from "./Backoffice.vue?vue&type=template&id=69049f42"
import script from "./Backoffice.vue?vue&type=script&lang=js"
export * from "./Backoffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports